/* template */
<template><div class="image-list" v-if="(show)"><mpx-image v-for="(item, index) in (list)" :key="item.image" :src="(item.image)" :style="[(item.style)] | transRpxStyle" mode="widthFix" webp class="image"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4bd21a8b"}'>
  .image-list
    text-align center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4bd21a8b"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./image-list.mpx.js?isComponent&outputPath=components%2Fimage-list4bd21a8b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./image-list.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fimage-list4bd21a8b%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4bd21a8b"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/image-list4bd21a8b/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
